export default "__VITE_ASSET__B5qnU3_n__"